import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import AuthenticationConfigurationStore
    from '../../stores/AuthenticationConfigurationSSO/AuthenticationConfigurationStore';
import { FTBody } from '../Fuse/Text';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';
import FuseAlert from '../FuseControls/FuseAlert';
import FuseCheckbox from '../FuseControls/FuseCheckbox';
import SnackStore from '../../stores/SnackStore';

import './ResetIDPModal.css';

const block = b.lock('ResetIDPModal');

class ResetIDPModal extends Component {
    static propTypes = {
        authenticationConfiguration: AuthenticationConfigurationStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    ResetIDP = () => {
        const { authenticationConfiguration } = this.props;
        authenticationConfiguration.deleteIDP().then(() => {
            this.props.snack.showSuccess('IdP has been reset.');
        }).catch(() => {
            this.props.snack.showError(AuthenticationConfigurationStore.GENERIC_FAILURE_MSG);
        });
    };

    render() {
        const { authenticationConfiguration } = this.props;
        return <FuseConsoleModal
            large
            isOpen={authenticationConfiguration.resetIdpModal.isOpen}
            onClose={authenticationConfiguration.resetIdpModal.close}
            greyBackground
            title="Reset IdP Configuration"
            headerActions={<FuseButton
                type={'primary'}
                color={'red'}
                loading={authenticationConfiguration.deleteIDPStatus.isLoading}
                disabled={!authenticationConfiguration.confirmResetIDP.isTrue}
                onClick={this.ResetIDP}
            >Reset</FuseButton>}
        >
            <FuseAlert
                title={'Reset Confirmation'}
                type="danger"
                className={block('Alert')}
            >
                <FTBody>{'Resetting the IdP settings will clear all entries and allow you to start a new ' +
                'IdP configuration. Any previous IdP connections will no longer function. ' +
                'This cannot be undone.'}</FTBody>
                <div className={block('ConfirmWrapper')}>
                    <FuseCheckbox
                        label={<FTBody
                            className={block('Label')}
                        >{'Confirm you want to reset this IdP configuration'}</FTBody>}
                        store={authenticationConfiguration.confirmResetIDP}
                        className={block('ConfirmCheckbox')}
                        black
                    />

                </div>

            </FuseAlert>
        </FuseConsoleModal>;
    }
}

export default inject('authenticationConfiguration', 'snack')(observer(ResetIDPModal));
